// FirestoreContext.js
import React, { createContext, useContext } from 'react';

const FirestoreContext = createContext(null);

export function FirestoreProvider({ firestore, children }) {
  if (!firestore) {
    throw new Error('FirestoreProvider requires a Firestore instance');
  }

  return (
    <FirestoreContext.Provider value={firestore}>
      {children}
    </FirestoreContext.Provider>
  );
}

export const useFirestore = () => useContext(FirestoreContext);
